import React from 'react'
import styled from 'styled-components'
import { loadFont } from 'loankeeper-common/helpers/styles'
import { LocalLoader } from 'shared'

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;

  ${(props) =>
    props.iDisabled &&
    `
    filter: brightness(30%);
    pointerEvents: none;
  `};

  .lk-grid-wrapper {
    height: 100%;
    width: 100%;
    position: absolute;

    .ag-header {
      color: black !important;
      background-color: #d4eaff !important;
    }

    .ag-header-row *:not(i) {
      ${(props) => loadFont(props.theme.gridHeaderFont || '12px BPG Algeti')};
    }

    .ag-body *:not(i) {
      ${(props) => loadFont(props.theme.gridFont)};
    }

    .ag-menu-list :not(i) {
      ${(props) => loadFont(props.theme.gridContextMenuFont)};
    }

    .ag-row-selected {
      font-weight: bold;
      border-top: 1px solid black !important;
      border-bottom: 1px solid black !important;
    }

    .ag-header-cell {
      padding-left: 3px;
      padding-right: 0px;
    }

    .ag-header-cell-menu-button .ag-icon-menu {
      height: 15px;
    }

    .ag-header-cell-label .ag-header-cell-text {
      overflow: initial;
      text-overflow: initial;
      font-weight: bold;
    }

    .ag-header-cell-menu-button {
      position: absolute;
      top: 4px;
      height: 15px;
      right: 3px;
    }

    .ag-header .ag-icon-asc,
    .ag-header .ag-icon-desc,
    .ag-header .ag-icon-expanded,
    .ag-header .ag-icon-contracted,
    .ag-header .ag-icon-menu,
    .ag-header .ag-icon-filter {
      background-color: #5b9bd5 !important;
    }

    .ag-header .ag-icon-asc,
    .ag-header .ag-icon-desc {
      position: absolute;
      right: 17px;
      top: 5px;
      height: 15px;
    }

    .ag-header-cell-label {
      width: 100%;
    }

    .ag-react-container {
    }

    .ui.button.lk-button {
      padding: 0;
      margin: 0;
      background: transparent;

      .lk-icon {
        height: 1.4em !important;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -8.4px;
        margin-left: -8.4px;
      }
    }

    .ag-menu-column-select-wrapper {
      height: auto;
      padding-bottom: 10px;
      max-height: 400px;
    }

    .ag-menu-option-text {
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 120px;
      max-width: 170px;
      text-align: center;
      padding: 5px 0;
    }

    .ag-theme-blue .ag-menu .lk-row-identifier {
      font-weight: bold;
      opacity: 1;
      background-color: #d4eaff !important;
      margin-bottom: 0.25rem;
    }

    // status bar temporary
    .ag-cell-range-selected.ag-cell-focus {
      background-color: rgba(120, 120, 120, 0.4);
    }

    .ag-font-style {
      cursor: inherit;
    }

    .ag-menu .ag-menu-list {
      cursor: inherit;
      min-width: 200px;

      .ag-menu-option:not(:first-child) {
        margin-top: 0.15rem;
      }
      .ag-menu-option {
        display: flex;
        padding: 0;
        min-height: 30px;
        line-height: 18px;

        .ag-menu-option-icon {
          width: 26px;
          height: 30px;
          padding: 0 0 0 4px;

          > span {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            margin: 0;
          }
        }
      }

      .ag-menu-option-text {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
      }

      .ag-menu-option-shortcut,
      .ag-menu-option-popup-pointer {
        display: none;
      }
    }
  }

  .ag-cell-focus {
    ${(props) =>
      props.showCellFocus
        ? `
        border: 2px solid transparent;
        border-right: 1px dotted #9bc2e6;
        border-bottom: 1px dotted #9bc2e6;
        outline: none;
    `
        : `
        border-color: transparent !important;
        border-right: 1px dotted #9bc2e6 !important;
    `};
  }
`

export const GridLoadingProvier = (props) => {
  const { iDisabled, iShowCellFocus, iLoading, children } = props

  // @ts-ignore
  const loadingIndicator = <LocalLoader logoLoader loading renderChildren />

  return (
    <Wrapper className="lk-grid-container" showCellFocus={iShowCellFocus} iDisabled={iDisabled}>
      <div className="lk-grid-wrapper ag-theme-blue">
        <React.Suspense fallback={loadingIndicator}>{iLoading ? loadingIndicator : children}</React.Suspense>
      </div>
    </Wrapper>
  )
}
